module.exports = __webpack_public_path__ + "static/105_001-c057894e665ca6a42b09901925b894c5.jpg";